import React from 'react';
import { Box } from '@material-ui/core';
import { number, string, arrayOf, shape, func } from 'prop-types';
import { cardFormatType } from 'common/propTypes';
import { SUPPORTED_CARDS } from 'common/constants/payment';
import { useContent } from '../../../content/content-provider';
import formatPrice from '../../../common/utils/format-price';
import {
  BillBody,
  GrandTotal,
  SummaryLine,
  PaymentsMade,
  AlertBanner,
} from '../../../common/components';

const GiftCardSummary = ({
  totalToPay,
  currency,
  cardPaymentAmount,
  giftCards,
  removeGiftCard,
  payments,
  cardFormatObj: { brands, cardPrefix },
}) => {
  const [content] = useContent();

  return (
    <Box pt={6}>
      <BillBody>
        <Box width="100%" py={1}>
          <SummaryLine
            leftContent={content.giftCardSummary.totalToPay}
            rightContent={formatPrice(totalToPay, currency)}
          />
          <PaymentsMade
            payments={payments}
            giftCards={giftCards}
            brands={brands}
            cardPrefix={cardPrefix}
            removeGiftCard={removeGiftCard}
            currency={currency}
          />
        </Box>
        {!!cardPaymentAmount && (
          <GrandTotal
            grandTotal={cardPaymentAmount}
            grandTotalCopy={content.giftCardSummary.outstanding}
            currency={currency}
          />
        )}
      </BillBody>
      {!cardPaymentAmount && (
        <Box pt={4}>
          <AlertBanner variant="info" dataTestid="remainingBalance">
            {content.giftCardSummary.successMessage}
          </AlertBanner>
        </Box>
      )}
    </Box>
  );
};

GiftCardSummary.propTypes = {
  totalToPay: number.isRequired,
  currency: string.isRequired,
  cardPaymentAmount: number.isRequired,
  giftCards: arrayOf(
    shape({
      cardNumber: string.isRequired,
      redemptionAmount: number.isRequired,
    })
  ).isRequired,
  removeGiftCard: func,
  payments: arrayOf(
    shape({
      desc: string.isRequired,
      amount: number.isRequired,
    })
  ),
  cardFormatObj: cardFormatType,
};

GiftCardSummary.defaultProps = {
  payments: [],
  removeGiftCard: null,
  cardFormatObj: {
    brands: SUPPORTED_CARDS,
    cardPrefix: '*',
  },
};

export default GiftCardSummary;
